const baseURL= "https://atci.lkm.vodafoneacademy.accenture.com/vodafone-apis";

const url = process.env.NODE_ENV === 'development' 
                        ? "http://localhost:3011" 
                        : (window.location.href.split(".")[3]) === "staging"
                        ?"https://atci.lkm.vodafoneacademy.staging.accenture.com/vodafoneacademystage-apis"
                        :"https://atci.lkm.vodafoneacademy.accenture.com/vodafone-apis";
export { url }; 

export default baseURL;
